import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input, MultiRadio } from 'shared/components';
import './StorageRadioList.scss';

class StorageRadioList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checkedValue: props.checkedValue,
      inputValue: props.inputValue,
    };

    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  onSelectionChange(e) {
    const { value } = e.target;

    this.setState({
      checkedValue: value,
    });

    this.props.updateTc(e);
  }

  onInputChange(e) {
    const { value } = e.target;

    this.setState({
      inputValue: value,
    });

    this.props.updateTc(e);
  }

  render() {
    const { radioOptions, title, className, errorRadio, errorOther } = this.props;
    const { checkedValue, inputValue } = this.state;

    return (
      <div className={`storage-radio-list ${className}`}>
        <MultiRadio
          title={title}
          radioList={radioOptions}
          checkedValue={checkedValue}
          onChange={this.onSelectionChange}
          errors={errorRadio}
        />
        <Input
          size="w-100"
          type="text"
          name={`${radioOptions[0].name}Other`}
          id={`${radioOptions[0].name}Other`}
          value={inputValue}
          onChange={this.onInputChange}
          errors={errorOther}
          disabled={checkedValue !== 'other'}
        />
      </div>
    );
  }
}

StorageRadioList.propTypes = {
  radioOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  updateTc: PropTypes.func.isRequired,
  checkedValue: PropTypes.string,
  inputValue: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
  t: PropTypes.func.isRequired,
};

StorageRadioList.defaultProps = {
  className: '',
  inputValue: '',
  checkedValue: '',
  title: '',
};

export default StorageRadioList;
